import theme from "@/theme";

export const styles = {
  container: {
    padding: "0 16px",
    backgroundColor: "#FFFFFF",
    margin: "0px",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#FFFFFF",
    padding: "20px 40px 5px 40px",
    gup: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tableHead: {
    height: "48px",
    borderRadius: "8px",
  },
  tableContainer: {
    boxShadow: "none",
    maxHeight: "90%",

    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: "#FFFFFF",
  },

  tableHeadCell: {
    height: "48px",
    backgroundColor: "#F5F9FE",
    padding: "0",
    fontSize: "16px",
    color: "#2A2D31",
    border: "none",
    fontWeight: 600,
  },
  tableHeadText: {
    maxWidth: "160px",
    height: "48px",
    padding: "0 5px 0 24px",
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0%",
    display: "flex",
    alignItems: "center",
  },
  tableHeadTextName: {
    width: "300px",
  },
  tableCell: {
    paddingY: 2,
    border: "none",
  },
  nameCellBox: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
  },
  nameText: {
    fontWeight: 600,
  },
  symbolText: {
    fontSize: "0.75rem",
    color: "#76839b",
  },
  sentimentBox: (color: "green" | "red") => ({
    display: "flex",
    alignItems: "center",
    color: color === "green" ? "#00c853" : "#d32f2f",
    fontWeight: 500,
  }),
  ArrowsDiagram: {
    height: "24px",
    width: "24px",
    padding: "8px 0 0 0",
    cursor: "pointer",
    flexShrink: 0,
  },
  likeBox: {
    display: "flex",
    alignItems: "center",
    color: "#d32f2f",
  },
  starButton: {
    color: "#007bff",
  },
  tabsBox: {
    display: "flex",
    gap: 3,
  },

  tabItem: (active: boolean) => ({
    cursor: "pointer",
    color: active ? theme.palette.custom.mainBlue : "#4f5b67",
    borderBottom: active ? `2px solid ${theme.palette.custom.mainBlue}` : "none",
    pb: "4px",
    fontWeight: active ? 600 : 500,
  }),

  sortBox: {
    justifyContent: "space-between",
    display: "flex",
    padding: "20px 0",
  },
  filtersWrapper: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    rowGap: "16px",
    columnGap: "16px",
    height: "auto",
    opacity: 1,
  },

  tableRelativeWrapper: {
    position: "relative",
    width: "100%",
  },
  unlockButtonOverlay: {
    position: "absolute",
    top: "280px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 10,
  },
  unlockButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 12px",
    borderRadius: "42px",
    backgroundColor: theme.palette.custom.mainBlue,
    textTransform: "none",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    "&:hover": { backgroundColor: "#1F6FE0" },
  },
  unlockButtonText: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    letterSpacing: "-0.15px",
    color: "#FFFFFF",
  },
  floatingUnlockWrapper: {
    position: "fixed",
    bottom: "24px",
    transform: "translateX(-50%)",
    zIndex: 20,
  },
};
